/* global axios */

import ApiClient from './ApiClient';

// Integrações › Claude: Claude conectado por usuários da empresa (login OAuth
// pelo conector MCP) e aprovações de mensagens para o cliente.
class ClaudeConnectionsAPI extends ApiClient {
  constructor() {
    super('claude_connections', { accountScoped: true });
  }

  approve(approvalId) {
    return axios.post(`${this.url}/approvals/${approvalId}/approve`);
  }

  reject(approvalId) {
    return axios.post(`${this.url}/approvals/${approvalId}/reject`);
  }
}

export default new ClaudeConnectionsAPI();
